// Driver speed is recorded by the driver app (and the browser Geolocation API) in
// metres per second, and the backend stores and returns it unchanged. Anything shown to
// a user as "km/h" must go through these helpers, otherwise a vehicle doing 60 km/h
// (~16.7 m/s) is displayed as "16.7 km/h".

const MS_TO_KMH = 3.6;

// m/s -> km/h. Returns null when there is no usable speed (missing, NaN, or not > 0).
export const msToKmh = (metresPerSecond) => {
  const value = typeof metresPerSecond === 'string' ? parseFloat(metresPerSecond) : metresPerSecond;
  if (value == null || Number.isNaN(value) || value <= 0) return null;
  return value * MS_TO_KMH;
};

// m/s -> display string such as "62 km/h", or `fallback` when there is no speed.
export const formatSpeedKmh = (metresPerSecond, { decimals = 0, fallback = 'N/A' } = {}) => {
  const kmh = msToKmh(metresPerSecond);
  return kmh == null ? fallback : `${kmh.toFixed(decimals)} km/h`;
};
